import { useState } from "react";
import { Link } from "react-router-dom";
import { Avatar, Modal } from "antd";
import { FileImageOutlined } from "@ant-design/icons";
import Flooring from "components/flooring";
import { TFlooring } from "../helpers/flooring-types-helper";
import Icons from "components/icons";

interface IFlooringImageFieldProps
{
  flooring: TFlooring;
  grid?: boolean;
}

type TImageSize = "200x200" | "original";

const FlooringImageField: React.FC<IFlooringImageFieldProps> = ({ flooring, grid = false }) =>
{
  const [ modalVisible, setModalVisible ] = useState(false);

  const handleImageClick = () =>
  {
    setModalVisible(true);
  };

  const handleCloseModal = () =>
  {
    setModalVisible(false);
  };

  const getImageUrl = (size: TImageSize) =>
  {
    return flooring?.images?.length ? flooring.images[ 0 ]?.sizes[ size ] : undefined;
  };


  return (
    <>
      {!grid ? (
        <div className="d-flex align-items-center">
          <div
            style={{
              minWidth: "60px",
              cursor: getImageUrl("200x200") && "pointer",
            }}
            onClick={handleImageClick}
          >
            <Avatar
              shape="square"
              size={50}
              icon={
                getImageUrl("200x200") ? (
                  <img src={getImageUrl("200x200")} alt="img" />
                ) : (
                  <FileImageOutlined />
                )
              }
            />
          </div>
        </div>
      ) : (
        <div>
          <Link
            className="card-image"
            to={`${Flooring.Const.basePath}/${flooring?.id}/`}
          >
            <Avatar
              shape="square"
              size={100}
              icon={
                getImageUrl("200x200") ? (
                  <img src={getImageUrl("200x200")} alt="img" />
                ) : (
                  <FileImageOutlined />
                )
              }
            />
          </Link>

          {getImageUrl("200x200") && (
            <div className="icon-zoom" onClick={handleImageClick}>
              <Icons.Zoom />
            </div>
          )}
        </div>
      )}

      {getImageUrl("original") && (
        <Modal
          className="modal-image"
          width={800}
          open={modalVisible}
          onCancel={handleCloseModal}
          closeIcon={<Icons.Close />}
          footer={null}
          centered
        >
          <img
            src={getImageUrl("original")}
            alt="img"
            style={{ width: "100%" }}
          />
        </Modal>
      )}
    </>
  );
};

export default FlooringImageField;
